export enum ProductType {
  REAL_OBJECT = 0,
  DOWNLOADABLE_VIRTUAL = 1,
  DEFAULT = 2
}
